import { useQuery } from '@tanstack/react-query';

import { bopsApi } from '@Network';

const usePermissions = () => {
  return useQuery({
    queryKey: ['permissions'],
    queryFn: () => bopsApi.getAvailablePermissions(),
  });
};

export default usePermissions;
